export default __webpack_public_path__ + "static/media/SIMONA AG.391e9fc5.png";